/* eslint-disable @typescript-eslint/no-explicit-any */
import { cloneDeep } from 'lodash';
import {acFilterTypes } from '../acReduxExports';
import rmsStore from '../../../rmsReduxStore/rmsStore';
import { acChargerPanelInitialFilterValues, alarmInitialFilterValues, chargerInitialFilterValues ,globalFiltersInitialState,chargingHistoryReportInitialFilterValues, dashboardV2InitialFilterValues, customerChargerInitialFilterValues , parametersInitialFilterValues ,latestChargerStatusLogsInitialFilterValues , chargerLogsReportInitialFilterValues , versionReleasesDashboardInitialFilterValues,versionReleasesInitialFilterValues,chargingSessionTrendInitialFilterValues, exceptionLogsReportInitialFilterValues,chargingVsIdleInitialFilterValues , overallUptimeInitialFilterValues , nocDashboardInitialFilterValues , nocPerfomanceAnalyticsIntialFilterValues ,configureNotificationInitialFilterValues , configureNotificationHistoryInitialFilterValues, acSoftwareVersionDeploymentLogsInitialFilterValues, acChargerCertificatesInfoInitialValues } from './acFiltersReducer';

export const setAcFilterData = (data, filterKey: string, screenName: string, action: 'SET' | 'CLEAR', isGlobal: boolean, excludeGlobalFilters?: boolean,clearGlobalFilters?:boolean) => async (dispatch): Promise<AcFilterUpdateResolve> => {
    // eslint-disable-next-line no-async-promise-executor
    return new Promise(async (resolve, reject) => {
        try {
            let globalFilters: AcInnerFilterState[] = cloneDeep(rmsStore.getState().acFilterReducer.globalFilters);
            const screenFilters: AcScreenFilterState[] = cloneDeep(rmsStore.getState().acFilterReducer.screenFilters);

            if (isGlobal) {
                const selectedGlobalFilter = globalFilters?.find((filter) => filter?.key === filterKey);
                if (selectedGlobalFilter) {
                    selectedGlobalFilter.value = Array.isArray(data) ? data : [data]
                }
                const action: Partial<ACFilterDataAction> = {
                    type: acFilterTypes.SET_GLOBAL_AC_FILTERS_DATA,
                    globalFilters: globalFilters,
                };
                await dispatch(action);
            }

            if (action === 'SET' && !isGlobal) {
                const selectedScreenFilters = screenFilters?.find((filter) => filter?.screen === screenName);
                const selectedScreenSelectedFilter = selectedScreenFilters?.filters?.find((filter => filter?.key === filterKey));
                if (selectedScreenSelectedFilter) {
                    selectedScreenSelectedFilter.value = Array.isArray(data) ? data : [data]
                }
                const action: Partial<ACFilterDataAction> = {
                    type: acFilterTypes.SET_SCREEN_AC_FILTERS_DATA,
                    screenFilters: screenFilters,
                };
                await dispatch(action);
            }

            /* CLEAR ACTION WILL COME ONLY WHEN ALARMS OR CHARGERS DA    SHBOARD ARE UNMOUNTED
                AND FILTERS WERE APPLIED FROM REDIRECTION */
            if (action === 'CLEAR') {
                if(clearGlobalFilters) {
                    globalFilters = globalFiltersInitialState
                    const globalAction: Partial<ACFilterDataAction> = {
                        type: acFilterTypes.SET_GLOBAL_AC_FILTERS_DATA,
                        globalFilters: globalFilters,
                    };
                    await dispatch(globalAction);
                }
                const initialScreenFilterValues = {
                    'acchargers': chargerInitialFilterValues,
                    'acalarms': alarmInitialFilterValues,
                    'acchargerPanel':acChargerPanelInitialFilterValues,
                    'acchargingHistoryReport':chargingHistoryReportInitialFilterValues,
                    'acdashboard':dashboardV2InitialFilterValues,
                    'customerCharger':customerChargerInitialFilterValues,
                    'parameters':parametersInitialFilterValues,
                    'chargerLogsReport':chargerLogsReportInitialFilterValues,
                    'nocDashboard': nocDashboardInitialFilterValues,
                    'nocPerfomanceAnalytics':nocPerfomanceAnalyticsIntialFilterValues,
                    'latestChargerStatusLogs':latestChargerStatusLogsInitialFilterValues,
                    'versionReleases': versionReleasesInitialFilterValues,
                    'versionReleasesDashboard':versionReleasesDashboardInitialFilterValues,
                    'chargingSessionTrend':chargingSessionTrendInitialFilterValues,
                    'exceptionLogsReport':exceptionLogsReportInitialFilterValues,
                    'chargingVsIdle':chargingVsIdleInitialFilterValues,
                    'overallUptime':overallUptimeInitialFilterValues,
                    'acConfigureNotification' : configureNotificationInitialFilterValues,
                    'acConfigureNotificationHistory' : configureNotificationHistoryInitialFilterValues,
                    'acSoftwareVersionDeploymentLogs': acSoftwareVersionDeploymentLogsInitialFilterValues,
                    'acChargerCertificates': acChargerCertificatesInfoInitialValues
                }
                const selectedScreenFilters = screenFilters?.find((filter) => filter?.screen === screenName);
                if (selectedScreenFilters) {
                    selectedScreenFilters.filters = initialScreenFilterValues[screenName]
                }
                const action: Partial<ACFilterDataAction> = {
                    type: acFilterTypes.SET_SCREEN_AC_FILTERS_DATA,
                    screenFilters: screenFilters,
                };
                await dispatch(action);
            }
            const globalFiltersToBeSent: AcFilters[] = globalFilters?.map((item) => {

                return {
                    key: item.key,
                    values: item.value?.map((item) => item.id) || []
                }
            })
            const screenFiltersToBeSent: AcFilters[] = screenFilters?.find((filter) => filter.screen === screenName)?.filters.map((item) => {

        if (item.key === 'nocTimeSelectionInterval' || item.key === 'acUptimeQuickDateRange') {
            return {
                    key: item.key,
                    values: item.value?.map(v => v?.value ?? v) || []
                    };
         }
         if (
            item.key === 'alarmClearedTimeStamp' || item.key === 'alarmSetTimeStamp' || item.key === 'chargingHistoryInterval' || item.key === 'setInterval' || item.key ==='setIntervalUpdateCommand' || item.key === 'chargerLogStatusInterval' || item.key === 'chargerLogSettingInterval' || item.key === 'chargerLogSystemLogInterval' || item.key === 'versionReleaseDateInterval' ||  item.key === 'logInterval' || item.key === 'alarmRuleCreatedAtInterval' || item.key === 'alarmRuleUpdatedAtInterval' || item.key === 'fireTime' || item.key === 'swVersionRequestedOnInterval' 
            || item.key === 'certificateExpiryIntervalRange' || item.key === 'certificateCreatedAtInterval' || item.key === 'acUptimeReportDateRangeInterval'
         ) {

         if (item.key === 'fireTime') {

                        return {
                            key: item.key,
                            values: ['custom', ...item.value?.map(item => item && new Date(item)?.toISOString()) || []]
                        };
                    } 
            else
            return {
                key: item.key,
                values: item.value?.map(item => item && new Date(item)?.toISOString()) || []
            }
            
        }
        else if (item.key === 'historyInterval' && (item?.value?.[0] as IChargerHistoryIntervalRefData)?.id === 'custom') {
                    return {
                        key: item.key,
                        values: item?.value?.map((item, index) => { return index === 0 ? item?.id : new Date(item)?.toISOString() }) || []
                    }
                } 

                return {
                    key: item.key,
                    values: item.value?.map((item) => item?.id) || []
                }
                

        
            }) || []
            const filtersToBeSent = excludeGlobalFilters ? [...screenFiltersToBeSent] : [...globalFiltersToBeSent, ...screenFiltersToBeSent];

            resolve({
                message: 'Action dispatched successfully',
                filters: filtersToBeSent
            });
        } catch (error) {
            // Reject the promise with the error
            reject(error);
        }
    });
};

export const getAcFilterSelectedValue: any = (filterKey: string, screenName: string, isGlobal): null | IChargerHistoryTypeRefData[] | IChargerHistoryIntervalRefData[] | IGeneralReferenceData[] | IDateRangeReferenceData[]|string[] => {
    const globalFilters: AcInnerFilterState[] = cloneDeep(rmsStore.getState().acFilterReducer.globalFilters);
    const screenFilters: AcScreenFilterState[] = cloneDeep(rmsStore.getState().acFilterReducer.screenFilters);

    if (isGlobal) {
        return globalFilters?.find((filter) => filter?.key === filterKey)?.value || null;
    }
    const selectedScreenFilters = screenFilters?.find((filter) => filter?.screen === screenName);
    return selectedScreenFilters?.filters?.find((filter => filter?.key === filterKey))?.value || null
}

export const getCurrentAcFiltersValues: any = (screenName: string, excludeGlobalFilters?: boolean): AcFilters[] => {
    const globalFilters: AcInnerFilterState[] = cloneDeep(rmsStore.getState().acFilterReducer.globalFilters);
    const screenFilters: AcScreenFilterState[] = cloneDeep(rmsStore.getState().acFilterReducer.screenFilters);

    const globalFiltersToBeSent: AcFilters[] = globalFilters?.map((item) => {
        return {
            key: item.key,
            values: item.value?.map((item) => item.id) || []
        }
    })
    const screenFiltersToBeSent: AcFilters[] = screenFilters?.find((filter) => filter.screen === screenName)?.filters?.map((item) => {

        if (item.key === 'nocTimeSelectionInterval' || item.key === 'acUptimeQuickDateRange') {
            return {
                    key: item.key,
                    values: item.value?.map(v => v?.value ?? v) || []
                    };
         }
         
        if (
            item.key === 'alarmClearedTimeStamp' || item.key === 'alarmSetTimeStamp' || item.key === 'chargingHistoryInterval' || item.key === 'setInterval' || item.key ==='setIntervalUpdateCommand' || item.key === 'chargerLogStatusInterval' || item.key === 'chargerLogSettingInterval' || item.key === 'chargerLogSystemLogInterval' || item.key === 'versionReleaseDateInterval' ||  item.key === 'logInterval' || item.key === 'alarmRuleCreatedAtInterval' || item.key === 'alarmRuleUpdatedAtInterval' || item.key === 'fireTime' || item.key === 'swVersionRequestedOnInterval' 
            || item.key === 'certificateExpiryIntervalRange' || item.key === 'certificateCreatedAtInterval' || item.key === 'acUptimeReportDateRangeInterval'
        ) {
            return {
                key: item.key,
                values: item.value?.map(item => item && new Date(item)?.toISOString()) || []
            }
        }
    if (item.key === 'historyInterval' && (item?.value?.[0] as IChargerHistoryIntervalRefData)?.id === 'custom') {
            return {
                key: item.key,
                values: item?.value?.map((item, index) => { return index === 0 ? item?.id : new Date(item)?.toISOString() }) || []
            }
        }
        return {
            key: item.key,
            values: item.value?.map((item) => item?.id) || []
        }
    }) || []

    const filtersToBeSent = excludeGlobalFilters ? [...screenFiltersToBeSent] : [...globalFiltersToBeSent, ...screenFiltersToBeSent]
    return filtersToBeSent
}

export const getCurrentScreenAppliedAcFiltersCount: any = (screenName: string, excludeGlobalFilters?: boolean): number => {
    const globalFilters = rmsStore.getState().acFilterReducer.globalFilters;
    const screenFilters = rmsStore.getState().acFilterReducer.screenFilters;
    let globalFilterCount: number = 0
    globalFilters?.map((item) => {
        globalFilterCount += item?.value && item?.value?.length > 0 ? 1 : 0
    })
    let screenFilterCount: number = 0
    screenFilters?.find((filter) => filter.screen === screenName)?.filters.map((item) => {
        screenFilterCount += item?.value && item?.value?.length > 0 && item?.value?.[0] ? 1 : 0
    })
    const appliedFiltersCount = excludeGlobalFilters ? screenFilterCount : screenFilterCount + globalFilterCount
    return appliedFiltersCount
}


